import { createSlice } from "@reduxjs/toolkit";

// api client
import apiClient from "./apiClient.js";
import { toGraphQLQuery } from "./graphQLHelpers.js";

const REQUESTS = {
  index: (inspection_id) => {
    return `query {
      layers(inspectionId: "${inspection_id}") {
        ... on LayerOrthophoto {
          id
          type
          inspectionId
          name
          colorBar {
            url
            min {
              value
              unit
            }
            max {
              value
              unit
            }
          }
          sizeInPixels
          url
          maxZoom
          tfw_adbecf
          colorBar {
            url
            min {
              value
              unit
            }
            max {
              value
              unit
            }
          }
        }
        ... on LayerPhoto {
          id
          type
          inspectionId
          name
          colorBar {
            url
            min {
              value
              unit
            }
            max {
              value
              unit
            }
          }
          photos {
            id
            url
            geometry {
              type
              coordinates
            }
          }
        }
      }
    }
    `;
  },
  update: (fields) => {
    const { id, ...rest } = fields;
  
    const query = {
      id,
      ...rest
    };
  
    return `
      mutation {
        editLayer(layer: ${toGraphQLQuery(query)}) {
          ... on LayerOrthophoto {
            id
            name
            colorBar {
              url
              min {
                value
                unit
              }
              max {
                value
                unit
              }
            }
            sizeInPixels
            url
            maxZoom
            tfw_adbecf
          }
          ... on LayerPhoto {
            id
            dismissed
            inspectionId
            name
            type
            colorBar {
              url
              min {
                value
                unit
              }
              max {
                value
                unit
              }
            }
            updatedById
            updatedAt
            createdById
          }
        }
      }
    `;
  },
  delete: ({id}) => {
    return `
      mutation {
        deleteLayer(id: "${id}")
      }
    `;
  },
  createLayerFromOrthophoto: (fields, outputFields) => {
    const { inspectionId, projectId, orthophotoId } = fields;
  
    return `
      mutation {
        createLayerFromOrthophoto(layerInput: {
          inspectionId: "${inspectionId}",
          projectId: "${projectId}",
          orthophotoId: "${orthophotoId}"
        })
        {
          ... on LayerOrthophoto {
            ${outputFields}
          }
        }
      }
    `;
  }
};

const initialState = [
  // {
  //   id: "0",
  //   name: "Inspection",
  //   sizeInPixels:[18944,57600],
  //   url:"https://cornis-proxy-beta.herokuapp.com/maps/614830de1727800004ae86fd/cornis-dataclient/dong-energy/tiles/2021-8-23/H08-B-LE-WOF/H08-B-LE-WOF_merged_{x}_{y}_{z}.jpeg?token=zZsV6RgwZHLdyUUpmfSf",
  //   selected: true,
  //   coordSysX:[
  //     {
  //       name:"m",
  //       unit: "m",
  //       refs: [
  //         {
  //           coord: 0,
  //           value: 0
  //         },
  //         {
  //           coord: 18944,
  //           value: 100
  //         }
  //       ],
  //       hidden: false
  //     }
  //   ],
  //   coordSysY:[
  //     {
  //       name:"deg",
  //       unit: "deg",
  //       refs: [
  //         {
  //           coord: 0,
  //           value: -180
  //         },
  //         {
  //           coord: 57600,
  //           value: 180
  //         }
  //       ],
  //       hidden: false
  //     },
  //     {
  //       name:"m",
  //       unit: "m",
  //       refs: [
  //         {
  //           coord: 0,
  //           value: 0
  //         },
  //         {
  //           coord: 57600,
  //           value: 100
  //         }
  //       ],
  //       hidden: true
  //     }
  //   ],
  //   measure: [
  //     {
  //       name:"m",
  //       coordSys: [
  //         {
  //           axis: "x",
  //           name: "m"
  //         },{
  //           axis: "y",
  //           name: "m"
  //         }
  //       ]
  //     },
  //     {
  //       name: "deg",
  //       coordSys: [
  //         {
  //           axis: "y",
  //           name: "deg"
  //         }
  //       ]
  //     },
  //     {
  //       name: "pk",
  //       coordSys: [
  //         {
  //           axis: "x",
  //           name: "m"
  //         }
  //       ]
  //     }
  //   ]
  // }
];

export const layersApi = {
  index: async (inspectionId, next) => {
    //
    const result = await apiClient.req(REQUESTS.index(inspectionId));
    //
    next(result.data.data.layers);
  },
  update: async (fields, outputFields, next) => {
    const mutation = REQUESTS.update(fields, outputFields);
    const result = await apiClient.req(mutation);
    next(result.data.data.editLayer);
  },
  delete: async ({id}, next) => {
    const mutation = REQUESTS.delete({id});
    const result = await apiClient.req(mutation);
    next(result.data.data.deleteLayer);
  },
  createFromOrthophoto: async (fields, outputFields, next) => {
    const mutation = REQUESTS.createLayerFromOrthophoto(fields, outputFields);
    console.log(mutation)
    const result = await apiClient.req(mutation);
    console.log(result)
    next(result.data.data.createLayerFromOrthophoto);
  }
};

export const layersSlice = createSlice({
  name: "layers",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    toggleSelected: (state, { payload: { id } }) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      return state.map((layer) => {
        return {
          ...layer,
          selected: layer.id === id ? !layer.selected : layer.selected,
        };
      });
    },
    setLayers: (state, { payload: { layers } }) => {
      return layers.map((l) => {
        return {
          ...l,
          selected: true
        };
      });
    }
  },
});

export const { toggleSelected, setLayers } = layersSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectLayers = (state) => state.layers;
export const cursorPositioninUnits = (state) => {};

/** Infer homepage link type from inspection layers: orthophoto if any orthophoto layer, else photo if only photo layers, else orthophoto. */
export function getInspectionLinkType(inspection) {
  const layers = inspection?.layers || [];
  const hasOrtho = layers.some((l) => l.type === 'orthophoto');
  const hasPhoto = layers.length > 0 && layers.every((l) => l.type === 'photo');
  if (hasOrtho) return 'orthophoto';
  if (hasPhoto) return 'photo';
  return 'orthophoto';
}

export default layersSlice.reducer;